import { useEffect, useState } from 'react';
import Experiments from '@wix/wix-experiments';
import { experimentsStore } from '@wix/wix-vod-shared/common';

export const ExperimentsLoader = ({ children }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const wixExperiments = new Experiments({
      scope: 'vod',
      baseUrl: 'https://manage.wix.com',
    });

    wixExperiments.ready().then(() => {
      experimentsStore.set(wixExperiments.all());
      setLoaded(true);
    });
  });

  return loaded ? children : null;
};
